import React from 'react';
import ReactDOM from 'react-dom';
import styles from '../ManagePage.module.css';

const DeleteConfirmModal = ({ count, isDeleting, onCancel, onConfirm }) =>
  ReactDOM.createPortal(
    <div className={styles.deleteModal}>
      <div className={styles.deleteModalContent}>
        <h3>Confirm Deletion</h3>
        <p>
          Are you sure you want to delete {count} project{count !== 1 ? 's' : ''}?
          This action cannot be undone.
        </p>
        <div className={styles.deleteModalActions}>
          <button className={styles.cancelButton} onClick={onCancel} disabled={isDeleting}>
            Cancel
          </button>
          <button className={styles.confirmDeleteButton} onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );

export default DeleteConfirmModal;
